"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOME_TYPE = exports.LISTING_TYPES = exports.MODEL_TYPES = void 0;
exports.MODEL_TYPES = {
    DOUBLE_WIDE: 2,
    PARK_MODEL: 4,
    SINGLE_WIDE: 1,
    TRIPLE_WIDE: 3,
    UNSPECIFIED: 5,
};
exports.LISTING_TYPES = {
    FOR_PURCHASE: 1,
    FOR_RENT: 2,
    FOR_RENT_TO_OWN: 3,
};
exports.HOME_TYPE = {
    COMMUNITY: 2,
    MOBILE_HOME: 1,
};
